/* Tysk katalog for locale-commerce-preferences-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'pref.salesMode': 'Standardansicht für neue Verkäufe',
  'pref.salesModeSub': 'Gilt für Rechnung, Angebot, Auftragsbestätigung, Gutschrift und sonstige Verkäufe. Du kannst die Ansicht im Formular vorübergehend wechseln.',
  'pref.purchaseMode': 'Standardansicht für neue Einkäufe',
  'pref.purchaseModeSub': 'Wähle, ob neue Einkäufe normalerweise Schritt für Schritt oder mit dem ganzen Formular auf einer Seite geöffnet werden.',
  'pref.mode.firstChoiceHelp': 'Diese Auswahl wird dein Standard. Du kannst die Ansicht im Formular wechseln oder den Standard später unter Einstellungen → Präferenzen ändern.',
  'pref.mode.saveFailed': 'Die Ansicht wurde gewechselt, aber der Standard konnte nicht gespeichert werden. Versuche es erneut unter Einstellungen → Präferenzen.',
  'pref.mode.unsupported': 'Ungültige Ansichtsauswahl.',
});
